<glxy-form-field class="custom-input" [required]="fieldConfig.required">
  <input
    matInput
    type="text"
    [placeholder]="fieldConfig.placeHolder"
    [formControl]="theFormControl"
    [matAutocomplete]="auto"
  />
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="autocompleteDisplayFn">
    <mat-option *ngFor="let option of autocompleteOptions" [value]="option">
      {{ option.name }}
    </mat-option>
  </mat-autocomplete>
</glxy-form-field>
